export default __webpack_public_path__ + "static/media/deletarRed.765c30ef.svg";